export default "__VITE_ASSET__BF748oQa__"